import { mapState, mapMutations } from "vuex";
import ValidateMixin from "@/mixins/ValidateMixin.vue";
import ContentMixin from "@/mixins/ContentMixin.vue";
import ContentDisplayRulesMixin from "@/mixins/ContentDisplayRulesMixin.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import Popper from "vue3-popper";
import AppIcon from "@/components/AppIcon";
import AppModal from "@/components/AppModal";
import AppPopover from "@/components/AppPopover";
import ProductScore from "@/components/ProductScore";
import AppTableHeadSeo from "@/components/AppTableHeadSeo";
import AppTd from "@/components/AppTd";
import EditTextModal from "@/components/EditTextModal";
import ImageManagerModal from "@/components/ImageManagerModal";
import SeoEditItemNew from "@/components/SeoEditItemNew";
import ErrorOccured from "@/components/shared/ErrorOccured.vue";
import WrapWithCopy from "@/components/WrapWithCopy.vue";
import SeoRow from "@/components/seo/SeoRow.vue";
import { filterOut, EVENTS, stringsAreTheSameWithCaseSensitive } from "@/utils";
import { country_amz_sp_api_marketplace_ids_flipped } from "@/utils/countries";
export default {
  name: "ContentOptimisationTableNew",
  mixins: [ContentMixin, ValidateMixin, ContentDisplayRulesMixin, TasksMixin],
  emits: ["data-loading", "edit-single-item", "reset-paging-values", "push-status-list"],
  components: {
    Popper,
    AppIcon,
    AppModal,
    AppPopover,
    ProductScore,
    AppTableHeadSeo,
    AppTd,
    EditTextModal,
    ImageManagerModal,
    SeoEditItemNew,
    ErrorOccured,
    WrapWithCopy,
    // SeoImageRow,
    SeoRow
  },
  data() {
    return {
      editSingleItem: false,
      errorOccured: false,
      sellerAccounts: [],
      countriesMapping: [],
      content_list: [],
      imgWidth: "28px",
      imgHeight: "28px",
      imgBorder: "none",
      sortBy: "country",
      sortDesc: false,
      editTextModal: false,
      seoEditModal: false,
      editAsin: null,
      editValue: "",
      editOriginal: "",
      editContentId: "",
      editContentLink: "",
      editImage: "",
      editProductName: "",
      editItemHighlight: "",
      editSku: "",
      type: "",
      title: "",
      singleContentToPush: {},
      pushStatusList: {},
      modifiedAsins: [],
      contents_with_loading_state: [],
      sellerIds: [],
      selectAll: false,
      indeterminate: false,
      filter: {
        seller: "",
        country: "",
        sku: "",
        asin: ""
      },
      imageManagerModal: false,
      pushTaskIdentifier: "",
      pushModalActiveButton: true,
      pushModalSpinButton: false,
      confirmPushSingleContent: false,
      confirmPushSelectedContent: false,
      editSingleItem: false,
      showNavigationBtn: -1,
      isCollapsedImageList: true,
      showAcceptAmazon: false,
      errorMessage: {
        generic_keyword: "Too many characters - Amazon may consider none of the search terms"
      },
      showPopover: true
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      me: state => state.auth.me,
      products: state => state.content.list,
      modified_product_contents: state => state.content.modified_list,
      current_workspace: state => state.workspace.current_workspace,
      sellers_filter: state => state.content.sellers_filter,
      marketplaces_filter: state => state.content.marketplaces_filter,
      products_filter: state => state.content.products_filter,
      selected_contents: state => state.content.selected_contents,
      push_status_selected: state => state.content.push_status_selected,
      draft_list: state => state.content.draft_list,
      sync_error_list: state => state.content.sync_error_list,
      current_mode: state => state.content.current_mode,
      pushModal: state => state.content.pushModal,
      page: state => state.content.page,
      perPage: state => state.content.perPage,
      is_copying: state => state.content.is_copying
    }),
    workspaceCurrent() {
      return this.workspaceCurrentOld;
    },
    allowHtmlInputAndSpecialCharacters() {
      return ["product_description"].includes(this.type);
    },
    currentSellers() {
      return this.contentSellersSelectedGet();
    },
    sellersListSet() {
      return this.contentSellersListSet;
    },
    sellersSelectedSet() {
      return this.contentSellersSelectedSet;
    },
    countriesList() {
      return this.contentCountriesListGet();
    },
    countriesListSet() {
      return this.contentCountriesListSet;
    },
    countriesSelectedSet() {
      return this.contentCountriesSelectedSet;
    },
    currentCountries() {
      return this.contentCountriesSelectedGet();
    },
    contentsList() {
      return this.contentSuggestionsListGet();
    },
    contentsSelectedSet() {
      return this.contentSuggestionsSelectedSet;
    },
    currentContents() {
      return this.contentSuggestionsSelectedGet();
    },
    totalCountSet() {
      return this.contentTotalCountSet;
    },
    filtersSelectedForSearch() {
      return this.contentFiltersSelectedGet;
    },
    filtersSelectedForSpecificSearch() {
      return this.modifiedContentsSelectedGet();
    },
    filterOptions() {
      const result = {
        seller: [],
        country: [],
        sku: [],
        asin: []
      };
      this.products.forEach(item => {
        if (!result.seller.includes(item.seller_id)) {
          result.seller.push(item.seller_id);
        }
        const country = this.getCountry(item.marketplace_id);
        if (!result.country.includes(country)) {
          result.country.push(country);
        }
        if (!result.sku.includes(item.sku)) {
          result.sku.push(item.sku);
        }
        if (!result.asin.includes(item.asin)) {
          result.asin.push(item.asin);
        }
      });
      return result;
    },
    tableFields() {
      const tableHeaders = [{
        key: "product_name",
        label: "Product name",
        editable: true,
        stickyColumn: true,
        left: this.pushModal ? "20.4px" : "42px"
      }, {
        key: "item_highlight",
        label: "Item highlights",
        align: "center",
        editable: true,
        isNew: true
      }, {
        key: "points",
        label: "Bullet Points",
        colspan: 5,
        editable: true
      }, {
        key: "generic_keyword",
        label: "Search Terms",
        align: "center",
        editable: true
      }, {
        key: "product_description",
        label: "Description",
        editable: true
      }, {
        key: "a_plus",
        label: "A+",
        align: "center"
      }, {
        key: "media",
        label: "Media",
        align: "center"
      }, {
        key: "image_list",
        label: "",
        align: "start",
        expandable: "true",
        isCollapsed: this.isCollapsedImageList
      }, {
        key: "category",
        label: "Category",
        align: "center"
      }, {
        key: "brand",
        label: "Brand",
        align: "center"
      }, {
        key: "amz_score",
        label: "AMZ",
        align: "center",
        stickyColumn: true,
        right: this.pushModal ? "111px" : "147px"
      }, {
        key: "draft_score",
        label: "Omny",
        align: "center",
        stickyColumn: true,
        right: this.pushModal ? "79px" : "115px"
      }, {
        key: "push_status",
        label: "Push Status",
        align: "center",
        stickyColumn: true,
        right: this.pushModal ? "0px" : "36px"
      }, {
        key: "edit",
        align: "center",
        stickyColumn: true,
        showHeader: !this.pushModal,
        right: "0px"
      }];
      let headersWithCheckbox = [{
        key: "checkbox",
        label: "",
        stickyColumn: true,
        showHeader: true,
        left: "0px",
        align: "center"
      }, ...tableHeaders];
      //headersWithCheckbox.pop();
      //return this.pushModal ? headersWithCheckbox : tableHeaders;
      return headersWithCheckbox;
    },
    filteredItems() {
      return this.products.map(item => {
        const rulesOmnyScore = this.statusValidate(item, "omny");
        const rulesAmzScore = this.statusValidate(item, "amazon");
        const country = this.getCountry(item.marketplace_id);
        const imageList = this.filterImageList(item.image_list);
        const productImage = this.getProductImage(item.image_list);
        const attributeTextStyles = {
          product_name: this.contentToDisplayTextStyle(item, "product_name"),
          item_highlight: this.contentToDisplayTextStyle(item, "item_highlight"),
          bullet_point_1: this.contentToDisplayTextStyle(item, "bullet_point_1"),
          bullet_point_2: this.contentToDisplayTextStyle(item, "bullet_point_2"),
          bullet_point_3: this.contentToDisplayTextStyle(item, "bullet_point_3"),
          bullet_point_4: this.contentToDisplayTextStyle(item, "bullet_point_4"),
          bullet_point_5: this.contentToDisplayTextStyle(item, "bullet_point_5"),
          generic_keyword: this.contentToDisplayTextStyle(item, "generic_keyword"),
          product_description: this.contentToDisplayTextStyle(item, "product_description")
        };
        return {
          product_type: item.product_type,
          listing_status: item.listing_status,
          image_small: productImage?.link,
          image_list: imageList,
          statusResultOmnyScore: rulesOmnyScore,
          statusOmnyScore: this.mValidateGlobalScore(rulesOmnyScore),
          statusResultAmzScore: rulesAmzScore,
          statusAmzScore: this.mValidateGlobalScore(rulesAmzScore),
          sku: item.sku,
          asin: item.asin,
          content_id: item.content_id,
          amazon_link: item.amazon_link,
          sync_errors: item.sync_errors,
          modified_attributes: item.modified_attributes,
          category_name: item.category_name,
          category_id: item.category_id,
          has_a_plus_content: item.has_a_plus_content,
          brand: item.brand,
          product_name: this.contentToDisplay(item, "product_name"),
          product_name_style: attributeTextStyles["product_name"],
          product_name_icon: this.contentIconToDisplay(item, "product_name"),
          item_highlight: this.contentToDisplay(item, "item_highlight"),
          item_highlight_style: attributeTextStyles["item_highlight"],
          item_highlight_icon: this.contentIconToDisplay(item, "item_highlight"),
          count_media: item.count_media,
          count_videos: item.count_videos,
          count_images: item.count_images,
          count_images_style: this.mValidateNumberOfImage(item.count_images),
          bullet_point_1: this.contentToDisplay(item, "bullet_point_1"),
          bullet_point_1_style: attributeTextStyles["bullet_point_1"],
          bullet_point_1_icon: this.contentIconToDisplay(item, "bullet_point_1"),
          bullet_point_2: this.contentToDisplay(item, "bullet_point_2"),
          bullet_point_2_style: attributeTextStyles["bullet_point_2"],
          bullet_point_2_icon: this.contentIconToDisplay(item, "bullet_point_2"),
          bullet_point_3: this.contentToDisplay(item, "bullet_point_3"),
          bullet_point_3_style: attributeTextStyles["bullet_point_3"],
          bullet_point_3_icon: this.contentIconToDisplay(item, "bullet_point_3"),
          bullet_point_4: this.contentToDisplay(item, "bullet_point_4"),
          bullet_point_4_style: attributeTextStyles["bullet_point_4"],
          bullet_point_4_icon: this.contentIconToDisplay(item, "bullet_point_4"),
          bullet_point_5: this.contentToDisplay(item, "bullet_point_5"),
          bullet_point_5_style: attributeTextStyles["bullet_point_5"],
          bullet_point_5_icon: this.contentIconToDisplay(item, "bullet_point_5"),
          generic_keyword: this.contentToDisplay(item, "generic_keyword"),
          generic_keyword_style: attributeTextStyles["generic_keyword"],
          generic_keyword_icon: this.contentIconToDisplay(item, "generic_keyword"),
          product_description: this.contentToDisplay(item, "product_description"),
          product_description_style: attributeTextStyles["product_description"],
          product_description_icon: this.contentIconToDisplay(item, "product_description"),
          country,
          attribute_text_styles: attributeTextStyles,
          flag: this.getCountryFlag(this.getCountryCode(country)),
          isSelected: this.selected_contents.includes(item.content_id),
          last_push_date: this.contentLastPushDate(item).text,
          show_omny_validation_status: this.contentShowOmnyValidationStatus(item),
          content_evaluation_status: this.contentEvaluateItem(item),
          statusPush: this.contentPushIconToDisplay(item, attributeTextStyles)
        };
      });
    },
    productsList() {
      return this.products;
    },
    tableItems() {
      //return [...this.sortedItems(this.filteredItems)];
      return [...this.filteredItems];
    },
    taskStatusMessages() {
      return {
        NOTASK: "Push to Amazon task is not running",
        PENDING: "Push to Amazon task is pending",
        STARTED: "Push to Amazon task is running",
        RETRY: "Push to Amazon task is being retried",
        SUCCESS: "Push to Amazon task is successful",
        FAILURE: "Push to Amazon task failed"
      };
    },
    isPushLoading() {
      return item => {
        return this.contents_with_loading_state.includes(item.content_id);
      };
    },
    // pushButtonName() {
    //   return this.selected_contents.length > 0
    //     ? "Push selected updates to Amazon"
    //     : "Push all updates to Amazon";
    // },
    pushButtonName() {
      return "Push selected updates to Amazon";
    }
  },
  async mounted() {
    //const data = await this.getCountries();
    //this.contentCountriesListSet(data)
    if (this.current_mode == "default") {
      try {
        window.$bus.on(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE, this.refreshContents);
        window.$bus.on(EVENTS.REFRESH_SEO_PAGE, this.refreshSellers);
        window.$bus.on(EVENTS.REFRESH_SEO_PAGE_COUNTRIES, this.refreshCountries);
        window.$bus.on(EVENTS.REFRESH_SEO_PAGE_CONTENT_AND_SUGGESTIONS, this.refreshContentsAndSuggestions);
        window.$bus.on(EVENTS.REFRESH_SEO_PAGE_SUGGESTIONS, this.refreshSuggestions);
        window.$bus.on(EVENTS.SEO_PUSH_MODAL_CANCEL, this.onPushModalCancel);
        window.$bus.on(EVENTS.SEO_PUSH_MODAL_SUBMIT_MODIFIED_CONTENT, this.onConfirmPushModalSubmitModifiedContent);
        window.$bus.on(EVENTS.SEO_PUSH_MODAL_OPEN, this.onAmazonPush);
        this.pushTaskIdentifier = this.current_workspace.workspace_id + "_" + "content_push";
        this.getAsyncUpdate(this.pushTaskIdentifier);
        this.checkTaskStatusPeriodically(this.pushTaskIdentifier);
        await this.refreshContentsAndSuggestions();
        this.createPushStatusList();
        this.errorOccured = false;
      } catch (error) {
        this.errorOccured = true;
      }
    }
  },
  methods: {
    ...mapMutations(["contentCurrentModeSet", "contentSelectedContentsSet", "contentPushModalStatusSet", "isCopyingSet"]),
    handleError() {
      this.$emit("data-loading", false);
      this.errorOccured = true;
    },
    sortedItems(items) {
      return items.sort((a, b) => {
        const aaa = a[this.sortBy];
        const bbb = b[this.sortBy];
        if (typeof aaa != "undefined" && typeof bbb != "undefined") {
          return this.sortDesc ? bbb.toLowerCase().localeCompare(aaa.toLowerCase()) : aaa.toLowerCase().localeCompare(bbb.toLowerCase());
        }
        return 0;
      });
    },
    toggleSelectAll(checked) {
      this.contentSelectedContentsSet(checked ? this.products.map(item => item.content_id) : []);
      this.selectAll = checked;
    },
    //toggleSelectAll(event) {
    //   const checked = event.target.checked;
    //   console.log("BEFORE", {
    //     checked,
    //     selected_contents: this.selected_contents,
    //     selectedLength: this.selected_contents.length,
    //     selectAll: this.selectAll,
    //     indeterminate: this.indeterminate,
    //   });
    //   if(this.selected_contents.length>0){
    //     this.contentSelectedContentsSet([]);
    //     this.selectAll=false;
    //     this.indeterminate=false;
    //     event.target.checked = false;
    //     event.target.indeterminate = false;
    //     return;
    //   }
    //   const computedItems = this.tableItems.filter((item) =>
    //     this.isPossibleToPush(item)
    //   );
    //   const selectedIds = checked
    //     ? computedItems.map((item) => item.content_id)
    //     : [];
    //   this.contentSelectedContentsSet(selectedIds);
    //   this.selectAll =
    //     computedItems.length == this.tableItems.length ? checked : false;
    //   this.indeterminate = !this.selectAll && selectedIds.length > 0;
    // },
    updateSelectedItems(item, isSelectedItem) {
      let item_suggestion = this.contentSuggestionsListGet().find(suggestion => item.asin == suggestion.asin);
      if (isSelectedItem) {
        this.handleContentSelect({
          item: item_suggestion,
          only: false
        });
      } else {
        this.handleContentDeselect(item_suggestion);
      }
    },
    selectItem($event, item) {
      if ($event) {
        this.contentSelectedContentsSet([...this.selected_contents, item.content_id]);
      } else {
        this.contentSelectedContentsSet(this.selected_contents.filter(selected_content_id => item.content_id != selected_content_id));
      }
      this.indeterminate = this.selected_contents.length > 0;
      //this.updateSelectedItems(item,$event.target.checked);
    },
    onEdit(item, type, title) {
      //console.log("item", item, type, title);
      if (!item.sku) {
        return;
      }
      const originalItem = this.products.find(el => el.content_id == item.content_id);
      if (originalItem && !this.pushModal && !this.confirmPushSingleContent) {
        this.editAsin = item.asin;
        this.editMarketplaceId = item.marketplace_id;
        //this.editValue = originalItem.omny_version[type]; //logic to show null
        // this.editValue = originalItem.omny_version[type]
        //   ? originalItem.omny_version[type]
        //   : originalItem.amazon_version[type];
        // this.editOriginal = originalItem.amazon_version[type]; //old logic for showing amazon version

        this.editValue = this.contentToDisplay(originalItem, type, true);
        this.editOriginal = originalItem.amazon_version[type];
        const notAcceptedStatus = ["not_accepted", "seller_central_not_accepted"];
        this.showAcceptAmazon = notAcceptedStatus.includes(item[type + "_style"].status) && originalItem?.amazon_version[type] != "";
        this.editTextModal = true;
        this.type = type;
        this.title = title;
        this.editProductName = item.product_name;
        this.editSku = item.sku;
        this.editImage = item.image_small;
        this.editItemHighlight = item.item_highlight;
        this.editDescription = item.product_description;
        this.editBulletPoints = [item.bullet_point_1 ?? "", item.bullet_point_2 ?? "", item.bullet_point_3 ?? "", item.bullet_point_4 ?? "", item.bullet_point_5 ?? ""];
        this.editContentId = item.content_id;
      }
    },
    async onPaste(item, type, title) {
      if (!item.sku) {
        return;
      }
      const originalItem = this.products.find(el => el.content_id == item.content_id);
      if (originalItem && !this.pushModal && !this.confirmPushSingleContent) {
        try {
          const copiedValue = await navigator.clipboard?.readText();
          const statusValidationMap = {
            product_name: this.mValidateTitle,
            product_description: this.mValidateDescription,
            bullet_point_1: this.mValidateBulletPoints,
            bullet_point_2: this.mValidateBulletPoints,
            bullet_point_3: this.mValidateBulletPoints,
            bullet_point_4: this.mValidateBulletPoints,
            bullet_point_5: this.mValidateBulletPoints,
            generic_keyword: this.mValidateKeyword,
            count_images: this.mValidateNumborOfImage
          };
          let validationStatus;
          if (statusValidationMap[type]) {
            validationStatus = statusValidationMap[type].call(this, copiedValue);
          }
          const isValid = validationStatus.status != "error";
          if (!isValid) {
            window.$bus.trigger("showDanger", {
              visible: true,
              message: validationStatus.text,
              delay: 59999 // Show alert less than 1 minute
            });
            this.isCopyingSet(false);
            return;
          }
          this.setConfigForSubmit(item, originalItem, type, copiedValue);
          this.title = title;
          this.onSubmit({
            mixpanel_event_name: "userPastedCopiedContent"
          });
          this.isCopyingSet(false);
        } catch (err) {
          window.$bus.trigger("showDanger", {
            visible: true,
            message: "Clipboard permission is denied. Please activate clipboard permission on your browser and try again",
            delay: 59999 // Show alert less than 1 minute
          });
          this.isCopyingSet(false);
          return;
        }
      }
    },
    onUpdate(val) {
      this.editValue = val;
    },
    handleIdle(data) {
      this.pushModalActiveButton = true;
      this.pushModalSpinButton = false;
      // if (data) {
      //   window.$bus.trigger("showWarning", {
      //     visible: true,
      //     message: this.taskStatusMessages[data.task_status],
      //   });
      // }
    },
    async handleFailed(data) {
      this.pushModalActiveButton = true;
      this.pushModalSpinButton = false;
      data.task_result?.map(item => this.contentRemoveLoadingState(item));
      data.task_result?.map(item => this.contentSelectedContentsSet(this.selected_contents.filter(selected_content_id => item.content_id != selected_content_id)));
      window.$bus.trigger("showDanger", {
        visible: true,
        message: this.taskStatusMessages["FAILURE"],
        delay: 59999 // Show alert less than 1 minute
      });
      //await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
    },
    async handleRunning(data) {
      this.pushModalActiveButton = false;
      this.pushModalSpinButton = true;
      data.task_result?.map(item => this.contentUpdateAfterPush(item));
      window.$bus.trigger("showInfo", {
        visible: true,
        message: this.taskStatusMessages[data.task_status],
        delay: 59999 // Show alert less than 1 minute
      });
      this.checkTaskStatusPeriodically(this.pushTaskIdentifier);
    },
    async handleFinished(data) {
      if (data.task_result && (data.task_result[0].push_status == "sync_error" || data.task_result[0].sync_errors.length > 0)) {
        this.handleFailed(data);
        return;
      }
      this.pushModalActiveButton = true;
      this.pushModalSpinButton = false;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      data.task_result?.map(item => this.contentUpdateAfterPush(item));
      data.task_result?.map(item => this.contentRemoveLoadingState(item));
      data.task_result?.map(item => this.contentSelectedContentsSet(this.selected_contents.filter(selected_content_id => item.content_id != selected_content_id)));
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: this.taskStatusMessages[data.task_status],
        delay: 5999 // Show alert less than 1 minute
      });
      //await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
    },
    // modifiedContentToPush() {
    //   return this.selected_contents.length > 0
    //     ? this.selected_contents
    //     : this.filteredItems;
    // },
    modifiedContentToPush() {
      return this.selected_contents;
    },
    async onSubmit(value, mixpanel_event_name) {
      this.contentFieldSet({
        asin: this.editAsin,
        type: this.type,
        value: this.editValue,
        content_id: this.editContentId
      });
      const data = await this.contentUpdate({
        params: {
          content_id: this.editContentId
        },
        mixpanel_event_name: mixpanel_event_name
      });
      if (data) {
        if (!this.modifiedAsins.includes(this.editAsin)) {
          this.modifiedAsins.push(this.editAsin);
        }
        this.editTextModal = false;
        this.editAsin = null;
        this.editValue = "";
        this.editOriginal = "";
        this.editContentId = "";
        this.type = "";
        this.title = "";
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
      }
    },
    onCloseEdit() {
      this.editTextModal = false;
      this.editAsin = null;
      this.editValue = "";
      this.editOriginal = "";
      this.editContentId = "";
      this.type = "";
      this.title = "";
      this.editImage = "";
      this.editProductName = "";
    },
    async onEditSingleItem(item) {
      if (!item.sku) {
        return;
      }
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: "userOpenedEditPage",
        properties: {}
      });
      this.$emit("edit-single-item", true);
      this.editSingleItem = true;
      this.editContentId = item.content_id;
      this.editContentLink = item.amazon_link;
    },
    async onEditSingleItemBack() {
      this.$emit("edit-single-item", false);
      this.editSingleItem = false;
      await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
    },
    onImageChange(item) {
      //we comment it temporarily because we might work on the image upload or image processing
      // const originalItem = this.products.find((el) => el.asin == item.asin);

      // this.imageManagerModal = true;
      // this.editAsin = item.asin;
      // this.editImage =
      //   originalItem.image_large ||
      //   originalItem.image_medium ||
      //   originalItem.image_small;

      //temporary solution
      let link = item.amazon_link;
      if (!link.startsWith("http://") && !link.startsWith("https://")) {
        link = "https://" + link;
      }
      window.open(link, "_blank");
    },
    onImageUpdate(val) {
      this.editImage = val;
    },
    onImageSubmit(val) {
      this.contentFieldSet({
        asin: this.editAsin,
        type: "image",
        value: val
      });
      if (!this.modifiedAsins.includes(this.editAsin)) {
        this.modifiedAsins.push(this.editAsin);
      }
      this.imageManagerModal = false;
      this.editAsin = null;
      this.editImage = "";
    },
    async onPushModalSubmitModifiedContent() {
      if (this.selected_contents.length > 0) {
        await this.onPushModalSubmit(this.modifiedContentToPush());
        this.contentSelectedContentsSet([]);
        this.selectAll = false;
      }
    },
    async onConfirmPushModalSubmitModifiedContent() {
      this.confirmPushSelectedContent = true;
    },
    getPushStatusClass(item) {
      return `seo-popover ${item.statusPush.status}`;
    },
    showNavigation(index) {
      this.showNavigationBtn = index;
    },
    hideNavigation() {
      this.showNavigationBtn = -1;
    },
    async isCopied(cell) {
      let table = this.$refs["seo-table-content"];
      if (!table) {
        return;
      }
      const scrollPosition = table.scrollTop;
      this.isCopyingSet(true);
      let copyClass = " is-copied";
      cell.className += copyClass;
      requestAnimationFrame(() => {
        table.scroll({
          behavior: "instant",
          top: scrollPosition
        });
      });
      setTimeout(() => {
        cell.className = cell.className.replace(copyClass, "");
        requestAnimationFrame(() => {
          table.scroll({
            behavior: "instant",
            top: scrollPosition
          });
        });
      }, 1000);
    },
    keydownEscHandler() {
      this.isCopyingSet(false);
    },
    keepFocus() {
      if (this.is_copying) {
        let divFocusable = this.$refs["seo-table"];
        divFocusable.focus();
      }
    },
    createPushStatusList() {
      this.pushStatusList["draft"] = this.filteredItems.filter(item => item.statusPush.status == "draft");
      this.pushStatusList["sync_error"] = this.filteredItems.filter(item => item.statusPush.status == "sync_error");
      this.$emit("push-status-list", this.pushStatusList);
    },
    filterImageList(imageList) {
      let array = [];
      imageList.forEach(image => {
        if (!array.some(item => item.variant === image.variant)) {
          array.push(image);
        }
      });
      array.forEach(image => {
        const priorityOrder = ["image_large", "image_medium", "image_small"];
        let hoverImage = imageList.sort((a, b) => priorityOrder.indexOf(a.image_size) - priorityOrder.indexOf(b.image_size)).find(img => img.variant === image.variant);
        image["hover_img_link"] = hoverImage.link;
        image["hover_img_size"] = hoverImage.image_size;
      });
      if (array.length < 9) {
        for (let i = array.length; i < 9; i++) {
          let emptyImage = {
            variant: "PT0" + (i - 1),
            image_size: "",
            link: "",
            hover_img_link: ""
          };
          array.push(emptyImage);
        }
      }
      return array;
    },
    getProductImage(imageList) {
      const priorityOrder = ["image_small", "image_medium", "image_large"];
      return imageList.sort((a, b) => priorityOrder.indexOf(a.image_size) - priorityOrder.indexOf(b.image_size)).find(img => img.variant === "MAIN");
    },
    expandImageList() {
      this.isCollapsedImageList = false;
      this.scrollToRight();
    },
    collapseImageList() {
      this.isCollapsedImageList = true;
    },
    scrollToRight() {
      let table = this.$refs["seo-table-content"];
      if (!table) {
        return;
      }
      this.$nextTick(() => {
        table.scroll({
          behavior: "smooth",
          left: table.scrollWidth
        });
      });
    },
    setConfigForSubmit(item, originalItem, key, copiedValue) {
      this.editAsin = originalItem.asin;
      this.editValue = copiedValue;
      this.editOriginal = originalItem.amazon_version[key];
      this.type = key;
      this.editContentId = item.content_id;
    },
    async handlePushItem(item) {
      // const originalItem = this.products.find(
      //   (element) => element.content_id == item.content_id
      // );
      // let all_attributes = Object.keys(originalItem.amazon_version);
      // let attributes_to_modify = new Set(
      //   originalItem.modified_attributes || []
      // );
      // all_attributes.map(async (attribute) => {
      //   if (
      //     !stringsAreTheSameWithCaseSensitive(
      //       item[attribute],
      //       originalItem.amazon_version[attribute]
      //     ) &&
      //     !attributes_to_modify.has(attribute)
      //   ) {
      //     const copiedValue = item[attribute];
      //     this.setConfigForSubmit(item, originalItem, attribute, copiedValue);
      //     attributes_to_modify.add(attribute);
      //     await this.onSubmit({
      //       mixpanel_event_name: "userPasteCopiedAmazonAttributeToOmnyVersion",
      //     });
      //   }
      // });
      // this.contentUpdateAfterPush({
      //   modified_attributes: [...attributes_to_modify],
      // });
      this.onConfirmPushSingleContent(item);
    },
    HidePopover() {
      this.showPopover = false;
    },
    ShowPopover() {
      this.showPopover = true;
    },
    async onPushModalCancel() {
      //this.$emit("data-loading", true);
      this.contentCurrentModeSet("default");
      this.contentPushModalStatusSet(false);
      this.singleContentToPush = {};
      this.confirmPushSingleContent = false;
      this.confirmPushSelectedContent = false;
      //this.clearAllFilters();
      //await this.refreshContents();
      //this.$emit("data-loading", false);
    }
  }
};